export function templatesToAdapted(items) {
  return items
    ? items.map((item) => {
        return templateToAdapted(item);
      })
    : null;
}

export function templateToAdapted(item) {
  //Resource
  return item
    ? {
        template_id: item.id,
        template_libelle: item.libelle,
        template_type: item.type,
        template_notification: item.notification,
        template_annulation: item.annulation,
        template_type_email_id: item.type_email_id,
      }
    : null;
}

export function adaptedToTemplate(item) {
  //Model
  return item
    ? {
        libelle: item.template_libelle,
        notification: item.template_notification,
        annulation: item.template_annulation,
        societe_id: item.template_societe_id,
        type_id: item.template_type_id,
        type_email_id: item.template_type_email_id,
      }
    : null;
}
